<template>
    <div>
        <h2 class="mb-8">{{ integration.name }} {{ __('general.settings') }}</h2>

        <form>
            <div v-for="(group, groupTitle) in groupedConfigs">
                <h4>{{ groupTitle }}</h4>
                <div class="row">
                    <div v-for="(configurable, key) in group" class="col-xl-6">
                        <div class="form-group">
                            <label class="font-weight-bold" v-text="configurable.label"/>
                            <integration-settings-input :configurable="configurable"
                                                        :errors="errorsForGroup(configurable.field)"
                                                        v-model="configsForStore[groupTitle][key]"/>

                            <span class="form-text text-muted" v-text="configurable.description"/>
                            <span v-if="!configurable.editable" class="form-text text-muted">
                        {{ __('store.value_cannot_be_processed') }}
                    </span>
                        </div>
                    </div>
                </div>
            </div>

            <button class="btn btn-primary" @click.prevent="submitForm">
                <span class="svg-icon svg-icon-md"><i class="text-white fas fa-save"></i></span>
                {{ __('actions.submit') }}
            </button>
        </form>
    </div>
</template>

<script>
import IntegrationSettingsInput from '@components/Store/Includes/IntegrationSettingsInput.vue'
import Navigation from './Nav/Navigation.vue'

export default {


    /*



    @deprecated



     */




    layout: Navigation,

    name: 'EditStoreIntegration',

    components: {
        IntegrationSettingsInput,
    },

    props: {
        errors: Object,

        store: Object,
        storeUuid: String,
        integration: Object,
        config: {
            types: [Object, Array],
        },
    },

    data() {
        return {
            configsForStore: {},
        }
    },

    beforeMount() {
        this.configsForStore = this.createConfigObject()
    },

    methods: {
        submitForm() {
            // this.$inertia.post(this.$route('store.integration.update', [this.storeUuid, this.integration.code]), {
            //     fields: this.transformConfigs(this.configsForStore),
            // })
        },

        createConfigObject() {
            let configs = {}
            let groupConfig = this.groupedConfigs

            for (let group in groupConfig) {
                configs[group] = {}

                for (let configurable in groupConfig[group]) {
                    let configTemp = groupConfig[group][configurable]

                    let config = {
                        value: configTemp.value || configTemp.default,
                        field: configTemp.field,
                        type: configTemp.input_type,
                    }

                    if (config.type === 'period') {
                        config.unit = configTemp.attachments_value
                            ? configTemp.attachments_value.unit
                            : Object.keys(configTemp.attachments.unit)[0]
                    }

                    configs[group][configurable] = config
                }
            }

            return configs
        },

        transformConfigs(configs) {
            const outputArray = {}

            for (const key in configs) {
                for (const item in configs[key]) {
                    const configurable = configs[key][item]
                    outputArray[configurable.field] = configs[key][item]
                }
            }

            return outputArray
        },

        errorsForGroup(name) {
            if (this.errors.hasOwnProperty(name)) {
                return [this.errors[name]]
            }

            return {}
        },
    },

    computed: {
        groupedConfigs() {
            let groups = {
                [this.__('general.settings_general')]: {},
            }

            for (let configurableField in this.config) {
                let configurable = this.config[configurableField]

                if (configurable.group) {
                    if (!groups.hasOwnProperty(configurable.group)) {
                        groups[configurable.group] = {}
                    }

                    groups[configurable.group][configurableField] = configurable
                } else {
                    groups[this.__('general.settings_general')][configurableField] = configurable
                }
            }
            return groups
        },
    },
}
</script>
